import { Component, OnInit, Input, OnDestroy, HostListener } from '@angular/core';

declare global {
  interface Window {
    _hsq: any[];
  }
}

@Component({
  selector: 'app-exit-intent-guard',
  template: `
    <!-- Exit Intent HubSpot Popup -->
    <div id="exit-intent-popup" class="exit-intent-popup-overlay" (click)="closeExitIntentPopup()">
      <div class="exit-intent-popup-content" (click)="$event.stopPropagation()">
        <div class="popup-header">
          <h3>Hvordan var din oplevelse?</h3>
          <button class="close-btn" (click)="closeExitIntentPopup()">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="currentColor"/>
            </svg>
          </button>
        </div>
        <div class="popup-body">
          <p class="exit-message">Vi vil gerne høre din mening</p>
          <div id="exit-intent-hubspot-form-container"></div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./exit-intent-guard.component.css']
})
export class ExitIntentGuardComponent implements OnInit, OnDestroy {
  @Input() formId: string = 'aea85541-fbe4-4c26-b270-6af388ad2cf4';
  @Input() portalId: string = '3348448';
  @Input() region: string = 'na1';

  private hasShownPopup: boolean = false;

  ngOnInit() {
    this.initializeHubSpot();
  }

  ngOnDestroy() {
    // Clean up if needed
  }

  @HostListener('document:mouseleave', ['$event'])
  onMouseLeave(event: MouseEvent) {
    if (event.clientY <= 0 && !this.hasShownPopup) {
      this.showExitIntentPopup();
    }
  }

  @HostListener('document:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent) {
    if (!this.hasShownPopup) {
      this.showExitIntentPopup();
      event.preventDefault();
      event.returnValue = '';
      return '';
    }
  }

  private initializeHubSpot() {
    if (typeof window._hsq !== 'undefined') {
      return;
    }

    window._hsq = window._hsq || [];
    
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'hs-script-loader';
    script.async = true;
    script.defer = true;
    script.src = `//js.hs-scripts.com/${this.portalId}.js`;
    document.head.appendChild(script);
  }

  private showExitIntentPopup() {
    if (this.hasShownPopup) return;
    
    this.hasShownPopup = true;
    
    const popup = document.getElementById('exit-intent-popup');
    if (popup) {
      popup.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      
      setTimeout(() => {
        this.loadHubSpotForm();
      }, 100);
    }
  }

  public closeExitIntentPopup() {
    const popup = document.getElementById('exit-intent-popup');
    if (popup) {
      popup.style.display = 'none';
      document.body.style.overflow = 'auto';
    }
  }

  private loadHubSpotForm() {
    const container = document.getElementById('exit-intent-hubspot-form-container');
    if (!container) return;

    container.innerHTML = '';

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `https://js.hsforms.net/forms/embed/${this.portalId}.js`;
    script.defer = true;
    
    const formFrame = document.createElement('div');
    formFrame.className = 'hs-form-frame';
    formFrame.setAttribute('data-region', this.region);
    formFrame.setAttribute('data-form-id', this.formId);
    formFrame.setAttribute('data-portal-id', this.portalId);

    container.appendChild(formFrame);
    document.head.appendChild(script);
  }
} 


// WEBPACK FOOTER //
// ./src/app/shared/exit-intent-guard.component.ts